import { render, staticRenderFns } from "./PaymentDetails.vue?vue&type=template&id=1598f0d1"
import script from "./PaymentDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentDetails.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./i18n-payment-details.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Fchildren%2FPaymentDetails%2FPaymentDetails.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@/assets/locales/i18n-validations.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Fchildren%2FPaymentDetails%2FPaymentDetails.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports